import { render, staticRenderFns } from "./RepresentativeCommissionCustomerId.vue?vue&type=template&id=32578ab9&"
import script from "./RepresentativeCommissionCustomerId.vue?vue&type=script&lang=ts&"
export * from "./RepresentativeCommissionCustomerId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports